const firebaseConfig = `const firebaseConfig = {

  apiKey: "${import.meta.env.VITE_FIREBASE_API_KEY ?? "<YOUR_API_KEY>"}",

  authDomain: "${import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? "<YOUR_AUTH_DOMAIN>"}",

  projectId: "${import.meta.env.VITE_FIREBASE_PROJECT_ID ?? "<YOUR_PROJECT_ID>"}",

  storageBucket: "${import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ?? "<YOUR_STORAGE_BUCKET>"}",

  messagingSenderId: "${import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ?? "<YOUR_MESSAGING_SENDER_ID>"}",

  appId: "${import.meta.env.VITE_FIREBASE_APP_ID ?? "<YOUR_APP_ID>"}"

};`;

const projectId = import.meta.env.VITE_FIREBASE_PROJECT_ID ?? "Not configured";
const projectNumber = import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ?? "Not configured";
const appId = import.meta.env.VITE_FIREBASE_APP_ID ?? "Not configured";
const projectName = import.meta.env.VITE_FIREBASE_PROJECT_NAME ?? "Not configured";
const appNickname = import.meta.env.VITE_FIREBASE_APP_NICKNAME ?? "Not configured";

const FirebaseSettings = () => {
  return (
    <div className="min-h-screen bg-[#f7f8fb] text-slate-900">
      <div className="border-b border-slate-200 bg-white px-6 py-3 text-xs text-slate-500">
        Skip to main content
      </div>
      <div className="flex items-center gap-3 border-b border-slate-200 bg-white px-6 py-4">
        <div className="h-8 w-8 rounded-full bg-[#ffcb2d]" />
        <div>
          <p className="text-sm font-semibold text-slate-900">Firebase</p>
          <p className="text-xs text-slate-400">Project Overview</p>
        </div>
      </div>
      <div className="flex">
        <aside className="w-[270px] border-r border-slate-200 bg-white px-4 py-6">
          <div className="flex items-center gap-3 px-2">
            <div className="h-9 w-9 rounded-full bg-[#ffcb2d]" />
            <div>
              <p className="text-xs uppercase text-slate-400">Firebase</p>
              <p className="text-sm font-semibold">Project Overview</p>
            </div>
          </div>

          <div className="mt-6 space-y-2 text-sm">
            <p className="px-2 text-xs font-semibold uppercase text-slate-400">Project shortcuts</p>
            {['Authentication', 'Hosting', 'Data Connect', 'Firestore Database', 'Storage'].map((item) => (
              <button
                key={item}
                className="flex w-full items-center justify-between rounded-lg px-2 py-2 text-left text-slate-600 hover:bg-slate-100"
              >
                {item}
              </button>
            ))}
          </div>

          <div className="mt-6 space-y-2 text-sm">
            <p className="px-2 text-xs font-semibold uppercase text-slate-400">Product categories</p>
            {['Build', 'Run', 'Analytics', 'AI'].map((section) => (
              <div key={section} className="space-y-1">
                <p className="px-2 text-xs font-semibold text-slate-400">{section}</p>
                <div className="space-y-1">
                  {section === 'Build' && (
                    <>
                      {['App Check', 'App Hosting', 'Authentication', 'Data Connect', 'Extensions', 'Firestore Database', 'Functions', 'Hosting', 'Machine Learning', 'Realtime Database', 'Storage'].map((item) => (
                        <button
                          key={item}
                          className="flex w-full items-center justify-between rounded-lg px-2 py-1.5 text-left text-slate-500 hover:bg-slate-100"
                        >
                          {item}
                        </button>
                      ))}
                    </>
                  )}
                  {section === 'Run' && (
                    <>
                      {['A/B Testing', 'AdMob', 'App Distribution', 'Crashlytics', 'Dynamic Links', 'Messaging', 'Performance', 'Release Monitoring', 'Remote Config', 'Test Lab'].map((item) => (
                        <button
                          key={item}
                          className="flex w-full items-center justify-between rounded-lg px-2 py-1.5 text-left text-slate-500 hover:bg-slate-100"
                        >
                          {item}
                        </button>
                      ))}
                    </>
                  )}
                  {section === 'Analytics' && (
                    <>
                  {['Dashboard', 'Realtime Analytics', 'Events', 'Events Config', 'Network Settings', 'Audiences', 'Custom Definitions', 'Latest Release', 'DebugView'].map((item) => (
                    <button
                      key={item}
                      className="flex w-full items-center justify-between rounded-lg px-2 py-1.5 text-left text-slate-500 hover:bg-slate-100"
                        >
                          {item}
                        </button>
                      ))}
                    </>
                  )}
                  {section === 'AI' && (
                    <>
                      {['AI Logic', 'Genkit'].map((item) => (
                        <button
                          key={item}
                          className="flex w-full items-center justify-between rounded-lg px-2 py-1.5 text-left text-slate-500 hover:bg-slate-100"
                        >
                          {item}
                        </button>
                      ))}
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-6 space-y-2 px-2 text-xs text-slate-500">
            <p>Related development tools</p>
            <p>Firebase Studio</p>
            <div className="rounded-lg bg-slate-50 px-2 py-2 text-[11px] text-slate-500">
              <p className="font-semibold text-slate-600">Billing plan: Blaze</p>
              <p>Pay as you go</p>
            </div>
          </div>
        </aside>

        <main className="flex-1 px-10 py-8">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs font-semibold uppercase text-slate-400">Project settings</p>
              <h1 className="text-2xl font-semibold text-slate-900">Project settings</h1>
            </div>
            <button className="rounded-full border border-slate-200 bg-white px-4 py-2 text-sm text-slate-600 shadow-sm">
              Project settings
            </button>
          </div>

          <div className="mt-6 flex gap-6 border-b border-slate-200 text-sm text-slate-500">
            {['General', 'Cloud Messaging', 'Integrations', 'Service accounts', 'Data privacy', 'Users and permissions', 'Alerts', 'Your project'].map((tab) => (
              <button
                key={tab}
                className={`pb-3 ${tab === 'General' ? 'border-b-2 border-[#fbbc05] text-slate-900' : ''}`}
              >
                {tab}
              </button>
            ))}
          </div>

          <section className="mt-8 max-w-4xl space-y-8">
            <div className="rounded-xl border border-slate-200 bg-white p-6">
              <h2 className="text-lg font-semibold">Your project</h2>
              <div className="mt-4 grid gap-4 text-sm">
                <div className="flex items-center justify-between border-b border-slate-100 pb-3">
                  <span className="text-slate-500">Project name</span>
                  <span className="font-medium">{projectName}</span>
                </div>
                <div className="flex items-center justify-between border-b border-slate-100 pb-3">
                  <span className="text-slate-500">Project ID</span>
                  <span className="font-medium">{projectId}</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-slate-500">Project number</span>
                  <span className="font-medium">{projectNumber}</span>
                </div>
              </div>
            </div>

            <div className="rounded-xl border border-slate-200 bg-white p-6">
              <div className="flex items-center justify-between">
                <div>
                  <h2 className="text-lg font-semibold">Environment</h2>
                  <p className="text-sm text-slate-500">
                    This setting customizes your project for different stages of the app lifecycle
                  </p>
                </div>
                <div className="rounded-full border border-slate-200 px-3 py-1 text-xs text-slate-500">
                  Environment type <span className="ml-1 font-semibold text-slate-700">Unspecified</span>
                </div>
              </div>
            </div>

            <div className="rounded-xl border border-slate-200 bg-white p-6">
              <div className="flex items-center justify-between">
                <div>
                  <h2 className="text-lg font-semibold">Your apps</h2>
                  <p className="text-sm text-slate-500">Web apps</p>
                </div>
                <button className="rounded-full border border-slate-200 px-3 py-1 text-xs text-slate-500">
                  {appNickname}
                </button>
              </div>

              <div className="mt-6 rounded-lg border border-slate-200 bg-slate-50 p-4 text-sm">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-xs uppercase text-slate-400">Web App</p>
                    <p className="text-base font-semibold text-slate-900">THIRTEEN</p>
                  </div>
                  <div className="text-right text-xs text-slate-500">
                    <p>App nickname</p>
                    <p className="font-semibold text-slate-700">{appNickname}</p>
                  </div>
                </div>
                <div className="mt-3 text-xs text-slate-500">
                  App ID <span className="ml-2 font-semibold text-slate-700">{appId}</span>
                </div>
              </div>

              <div className="mt-6">
                <h3 className="text-sm font-semibold text-slate-900">SDK setup and configuration</h3>
                <div className="mt-3 flex gap-2 text-xs text-slate-500">
                  <button className="rounded-full bg-[#f1f3f5] px-3 py-1 font-semibold text-slate-900">npm</button>
                  <button className="rounded-full border border-slate-200 px-3 py-1">CDN</button>
                  <button className="rounded-full border border-slate-200 px-3 py-1">Config</button>
                </div>
                <p className="mt-3 text-sm text-slate-500">Get the snippet for your app's Firebase config object. Learn more.</p>
              </div>

              <div className="mt-4 rounded-lg border border-slate-200 bg-white p-4">
                <p className="text-xs font-semibold text-slate-400">Firebase configuration object containing keys and identifiers for your app:</p>
                <pre className="mt-3 overflow-x-auto rounded-lg bg-slate-900 px-4 py-3 text-xs text-slate-100">
                  <code>{firebaseConfig}</code>
                </pre>
                <p className="mt-4 text-xs text-slate-500">
                  Are you using npm and a bundler like webpack or Rollup? Check out the
                  <span className="font-semibold text-slate-700"> documentation</span>.
                </p>
                <p className="mt-2 text-xs text-slate-500">
                  Learn more about Firebase for web: Get Started, Web SDK API Reference, Samples
                </p>
                <p className="mt-2 text-xs text-slate-500">
                  Use this number to identify your app when you contact Firebase support.
                </p>
              </div>
            </div>
          </section>
        </main>
      </div>
    </div>
  );
};

export default FirebaseSettings;
